import React from "react";
import "./styles/App.css";
import Home from "./components/Home";

const App: React.FC = () => {
  return (
    <div className="App">
      <Home />
    </div>
  );
};

export default App;
